import script from "./NotasFiscaisTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotasFiscaisTabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__